import ConfirmationDialog from "@Components/app/common/confirmation-dialog";

const UpdateBlocker = ({ 
  open, 
  onExit = ()=> {}, 
  isUnityEmbedded = false
} : { 
  open: boolean, 
  onExit?: () => void, 
  isUnityEmbedded?: boolean 
}) => {
  return (
    <ConfirmationDialog
      open={open}
      disableCancel={true}
      disableConfirm={isUnityEmbedded === false}
      title="Update Required"
      message="A new version of BeYourBest is required. Please go to the app store on your device to update to the latest version."
      confirmLabel='button.exit.app'
      onConfirm={onExit}
    />
  );
};

export default UpdateBlocker;